export default function PlayCircle({
  className,
  width = 32,
  height = 32,
  ...rest
}: {
  className?: string
  width?: number
  height?: number
}) {
  return (
    <svg
      {...rest}
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M0 16C0 7.1634 7.1634 0 16 0s16 7.1634 16 16-7.1634 16-16 16S0 24.8366 0 16"
        fill="#F9F7F4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.7674 7.7686a.833.833 0 0 1 .8499.0304l11.6667 7.5a.8336.8336 0 0 1 0 1.402l-11.6667 7.5a.8334.8334 0 0 1-1.284-.701v-15a.833.833 0 0 1 .434-.7314M11 10.0264v11.9472L20.2923 16z"
        fill="#4D4A46"
      />
    </svg>
  )
}
